
// 展示Free
export const MissPriceArr = ['', '0', '0.00', '$0.00', '$0', 'US$0.00', 'US$0', 0, 0.00, undefined, 'free', 'Free', '-']

// 支付方式Code
export const PaymentCode = {
    adyenCard: 'Adyen_Card',
    adyenAfterPay: 'Adyen_AfterPay',
    adyenKlarna: 'Adyen_Klarna',
    adyenPayByBank: 'Adyen_Pay_By_Bank',
    adyenAffirmPay: 'Adyen_Affirm',
    klarna: 'klarna',
    paypal: 'paypal',
} as const;

// adyen 支付方式
export const AdyenPayCodeList = [
    PaymentCode.adyenCard,
    PaymentCode.adyenAfterPay,
    PaymentCode.adyenKlarna,
    PaymentCode.adyenPayByBank,
    PaymentCode.adyenAffirmPay,
]

// 跳转三方支付
export const AdyenThirdPayCodeList = [
    PaymentCode.adyenAfterPay,
    PaymentCode.adyenKlarna,
    PaymentCode.adyenPayByBank,
    PaymentCode.adyenAffirmPay,
]
export const CustomTipsModalPaymentCode = AdyenThirdPayCodeList


// 验证邮箱标记 （未登录 触发验证邮箱 登录后返回页面触发校验弹窗）
export const SESSION_STORAGE_VERIFY_EMAIL_MARK = 'SESSION_STORAGE_VERIFY_EMAIL_MARK';
